import React, { forwardRef } from "react"
import styled from "styled-components"
import { TextLink, TextVariant } from "../../atoms/text"

export type LinkExternalProps = {
  label: string
  link: string
  variant?: TextVariant
  openInNewTab?: boolean
  className?: string
  onClick?: () => void
}

export const LinkExternal = forwardRef<HTMLAnchorElement, LinkExternalProps>((props, ref) => {
  const { label, link, variant, openInNewTab = true, className, onClick } = props
  return (
    <Root ref={ref} href={link} target={openInNewTab ? "_blank" : "_self"} className={className}>
      <TextLink onClick={onClick} noWrap variant={variant}>
        {label}
      </TextLink>
    </Root>
  )
})

const Root = styled.a`
  text-decoration: none;
`
